import { Col, Form, Row, DatePicker, InputNumber, Select, Table, Button, message } from 'antd';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { showExport, updateServiceCharge } from '@app/api/export.api';

interface ServiceChargeProps {
  id?: string | null;
  serviceChargeOptions?: any[];
  serviceCharges?: any[];
  editable: boolean;
  form: any;
  exportData: any;
  canUpdateServiceCharges?: any;
  onSaveSuccess?: () => void;
}

const ServiceCharge: React.FC<ServiceChargeProps> = ({
  serviceCharges = [],
  editable,
  form,
  exportData,
  serviceChargeOptions,
  canUpdateServiceCharges,
  id,
  onSaveSuccess,
}) => {
  const [selectedServiceId, setSelectedServiceId] = useState<number | null>(null);
  const [serviceLines, setServiceLines] = useState<any[]>(exportData?.followup_lines ?? []);
  const [editingLine, setEditingLine] = useState<any | null>(null);

  useEffect(() => {
    console.log('can update service charge', canUpdateServiceCharges);
    if (exportData?.export_service_charges) {
      setServiceLines(
        exportData.export_service_charges.map((charge: any) => ({
          id: charge.id,
          export_id: charge.export_id,
          referenceable_type: 'Service',
          referenceable_id: charge.service_charge_id,
          service_name: charge.service_charge?.name,
          qty: parseFloat(charge.qty),
        })),
      );
    } else {
      setServiceLines([]);
    }
  }, [exportData, canUpdateServiceCharges]);

  useEffect(() => {
    if (editingLine) {
      form.setFieldsValue({
        id: editingLine.id,
        service_id: editingLine.referenceable_id,
        qty: editingLine.qty,
      });
      setSelectedServiceId(editingLine.referenceable_id);
    }
  }, [editingLine, form]);

  // const handleEdit = (index: number) => {
  //   const line = serviceLines[index];
  //   setEditingLine(line);
  // };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        export_service_charges: [
          {
            service_charge_id: values.service_id,
            qty: values.qty,
          },
        ],
      };

      await updateServiceCharge(exportData.id, payload);
      message.success('Service charge updated successfully');
      //showExport(Number(id));
      onSaveSuccess?.();
    } catch (err) {
      console.error(err);
      message.error('Failed to update service charge');
    }
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'service_name',
      key: 'name',
      render: (name: string) => name || 'N/A',
    },
    {
      title: 'Billing Qty',
      dataIndex: 'qty',
      key: 'qty',
    },
    // {
    //   title: 'Action',
    //   key: 'action',
    //   render: (_: any, __: any, index: number) =>
    //     editable ? (
    //       <Button type="link" onClick={() => handleEdit(index)}>
    //         Edit
    //       </Button>
    //     ) : null,
    // },
  ];

  return (
    <div>
      <br />

      {canUpdateServiceCharges && (
        <Row gutter={[16, 16]} align="bottom">
          <BaseCol xs={24} md={8}>
            <Form.Item label="Service" name="service_id" rules={[{ required: true }]}>
              <Select
                showSearch
                placeholder="Select service"
                optionFilterProp="label"
                style={{ width: '100%' }}
                onChange={(value) => setSelectedServiceId(value)}
                options={serviceChargeOptions}
              />
            </Form.Item>
          </BaseCol>
          <BaseCol xs={24} md={8}>
            <Form.Item label="Billing Quantity" name="qty" rules={[{ required: true }]}>
              <InputNumber min={0} style={{ width: '100%' }} />
            </Form.Item>
          </BaseCol>
          <BaseCol xs={24} md={8}>
            <Form.Item>
              <Button type="primary" onClick={handleSave} style={{ width: '100px' }}>
                Add
              </Button>
            </Form.Item>
          </BaseCol>
        </Row>
      )}
      <br />
      <h3>Service Charges</h3>
      <Table
        dataSource={serviceLines}
        columns={columns}
        rowKey={(record) => record.id ?? `${record.referenceable_type}-${record.referenceable_id}`}
        pagination={false}
        locale={{ emptyText: 'No service charges added' }}
      />
    </div>
  );
};

export default ServiceCharge;
